import { render, staticRenderFns } from "./LandlordProfileNameAddress.vue?vue&type=template&id=f7d65a08&scoped=true&"
import script from "./LandlordProfileNameAddress.vue?vue&type=script&lang=js&"
export * from "./LandlordProfileNameAddress.vue?vue&type=script&lang=js&"
import style0 from "./LandlordProfileNameAddress.vue?vue&type=style&index=0&id=f7d65a08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d65a08",
  null
  
)

export default component.exports